import { Col } from "@amzn/stencil-react-components/layout";
import { Select } from "@amzn/stencil-react-components/select";
import { Label } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

export interface KeyboardLayoutSelectProps {
  layouts: string[];
  value?: string;
  onChange: (layout: string) => void;
}

export const KeyboardLayoutSelect: FC<KeyboardLayoutSelectProps> = ({ layouts, value, onChange }) => {
  if (layouts.length === 0) return null;

  return (
    <Col gridGap="S200">
      <Label htmlFor="keyboard-layout-select">
        {getString("replacement.chooseDevice.keyboardLayoutLabel")}
      </Label>
      <Select
        id="keyboard-layout-select"
        dataTestId="keyboard-layout-select"
        options={layouts}
        value={value}
        onChange={onChange}
        width="100%"
      />
    </Col>
  );
};
